var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpriteSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: "#767676",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 8v8m-4-4h8"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D9CDB",
    d: "M17 2h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "google-g-logo-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21 12.207c0-.606-.054-1.18-.146-1.74h-8.659v3.456h4.958c-.222 1.134-.873 2.092-1.839 2.743v2.3h2.958C20.004 17.363 21 15.003 21 12.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.195 21.195c2.483 0 4.56-.827 6.077-2.23l-2.958-2.298c-.828.551-1.877.889-3.119.889-2.398 0-4.429-1.617-5.157-3.801h-3.05v2.368c1.51 3.003 4.613 5.072 8.207 5.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M7.038 13.755A5.336 5.336 0 0 1 6.748 12c0-.613.106-1.203.29-1.755V7.877h-3.05a9.089 9.089 0 0 0 0 8.246l3.05-2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.195 6.445c1.357 0 2.567.467 3.525 1.379l2.62-2.62c-1.585-1.487-3.662-2.4-6.145-2.4-3.594 0-6.697 2.07-8.207 5.073l3.05 2.368c.728-2.184 2.759-3.8 5.157-3.8z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "iccon-img-layers",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.815 13.333c.563 0 1.019-.456 1.019-1.018v-7.13c0-.562-.456-1.018-1.019-1.018h-7.13c-.562 0-1.018.456-1.018 1.018",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.315 6.667h-7.13c-.562 0-1.018.456-1.018 1.018v7.13c0 .562.456 1.018 1.019 1.018h7.13c.562 0 1.018-.456 1.018-1.018v-7.13c0-.562-.456-1.018-1.019-1.018z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.315 6.667h-7.13c-.562 0-1.018.456-1.018 1.018v7.13c0 .562.456 1.018 1.019 1.018h7.13c.562 0 1.018-.456 1.018-1.018v-7.13c0-.562-.456-1.018-1.019-1.018z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 14.17,
    height: 14.17,
    x: 4.17,
    y: 1.67,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_1297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_1297",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 14.17,
    height: 14.17,
    x: 1.67,
    y: 4.17,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_1297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_1297",
    result: "shape"
  }))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 8v8m-4-4h8"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D9CDB",
    d: "M17 2h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "google-g-logo-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21 12.207c0-.606-.054-1.18-.146-1.74h-8.659v3.456h4.958c-.222 1.134-.873 2.092-1.839 2.743v2.3h2.958C20.004 17.363 21 15.003 21 12.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.195 21.195c2.483 0 4.56-.827 6.077-2.23l-2.958-2.298c-.828.551-1.877.889-3.119.889-2.398 0-4.429-1.617-5.157-3.801h-3.05v2.368c1.51 3.003 4.613 5.072 8.207 5.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M7.038 13.755A5.336 5.336 0 0 1 6.748 12c0-.613.106-1.203.29-1.755V7.877h-3.05a9.089 9.089 0 0 0 0 8.246l3.05-2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.195 6.445c1.357 0 2.567.467 3.525 1.379l2.62-2.62c-1.585-1.487-3.662-2.4-6.145-2.4-3.594 0-6.697 2.07-8.207 5.073l3.05 2.368c.728-2.184 2.759-3.8 5.157-3.8z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "iccon-img-layers",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.815 13.333c.563 0 1.019-.456 1.019-1.018v-7.13c0-.562-.456-1.018-1.019-1.018h-7.13c-.562 0-1.018.456-1.018 1.018",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.315 6.667h-7.13c-.562 0-1.018.456-1.018 1.018v7.13c0 .562.456 1.018 1.019 1.018h7.13c.562 0 1.018-.456 1.018-1.018v-7.13c0-.562-.456-1.018-1.019-1.018z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.315 6.667h-7.13c-.562 0-1.018.456-1.018 1.018v7.13c0 .562.456 1.018 1.019 1.018h7.13c.562 0 1.018-.456 1.018-1.018v-7.13c0-.562-.456-1.018-1.019-1.018z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 14.17,
    height: 14.17,
    x: 4.17,
    y: 1.67,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_1297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_1297",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 14.17,
    height: 14.17,
    x: 1.67,
    y: 4.17,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_1297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_1297",
    result: "shape"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-more-vertical",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-more-vertical-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.416 11H4.583M11 17.417L4.583 11 11 4.583"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left-dark",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.416 11H4.583M11 17.417L4.583 11 11 4.583"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    fill: "#6521D3",
    stroke: "#6521D3",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 8v8m-4-4h8"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit-fill-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    fill: "#A16EE4",
    stroke: "#A16EE4",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 8v8m-4-4h8"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 21v-9h6v9"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 21v-9h6v9"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6521D3",
    stroke: "#6521D3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 21V11h8v10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6521D3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 21V11h8v10"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home-fill-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16EE4",
    stroke: "#A16EE4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 21V11h8v10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A16EE4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 21V11h8v10"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-message-circle-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6521D3",
    stroke: "#6521D3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.379 8.379 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-message-circle-fill-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16EE4",
    stroke: "#A16EE4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.379 8.379 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-image",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.417 2.75H4.583c-1.012 0-1.833.82-1.833 1.833v12.834c0 1.012.82 1.833 1.833 1.833h12.834c1.012 0 1.833-.82 1.833-1.833V4.583c0-1.012-.82-1.833-1.833-1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.792 9.166a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75zM19.25 13.75l-4.584-4.584L4.583 19.25"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6521D3",
    fillRule: "evenodd",
    d: "M21 19v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3c0-1.06.474-2.078 1.318-2.828C5.162 15.422 6.307 15 7.5 15h9c1.194 0 2.338.421 3.182 1.172C20.526 16.922 21 17.939 21 19z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6521D3",
    stroke: "#6521D3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-fill-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16EE4",
    fillRule: "evenodd",
    d: "M21 19v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3c0-1.06.474-2.078 1.318-2.828C5.162 15.422 6.307 15 7.5 15h9c1.194 0 2.338.421 3.182 1.172C20.526 16.922 21 17.939 21 19z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16EE4",
    stroke: "#A16EE4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location",
    viewBox: "0 0 18 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6521D3",
    fillRule: "evenodd",
    d: "M3.901 3.788C2.633 4.899 1.848 6.548 2.114 8.82l.006.075 7.127 11.196L15.88 8.929c0-.034.002-.07.006-.104.27-2.378-.523-4.044-1.779-5.136C12.815 2.565 10.947 1.98 9.014 2c-1.933.02-3.81.645-5.113 1.787zm13.843 5.654a.999.999 0 0 0 .13-.391c.341-3.004-.68-5.329-2.455-6.871C13.681.669 11.305-.024 8.993 0c-2.313.025-4.68.768-6.41 2.283C.819 3.83-.215 6.126.128 9.053c.017.152.068.29.143.412l-.114.072 8.276 13 .873 1.371.83-1.397 7.725-13-.117-.07zM7.534 6.444A1.245 1.245 0 0 0 7 7.5c0 .47.2.804.536 1.054.364.27.9.44 1.482.446.583.006 1.108-.153 1.46-.412.319-.236.525-.57.522-1.082-.003-.514-.215-.854-.54-1.093-.354-.26-.879-.419-1.458-.413-.579.006-1.11.175-1.47.444zm4.113-1.641c.803.59 1.346 1.508 1.354 2.69.007 1.187-.53 2.11-1.334 2.704-.772.57-1.749.812-2.668.803-.92-.01-1.889-.272-2.653-.84C5.554 9.575 5 8.668 5 7.5c0-1.164.548-2.07 1.336-2.659.762-.568 1.727-.831 2.646-.84.918-.01 1.891.233 2.664.802z",
    clipRule: "evenodd"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location-dark",
    viewBox: "0 0 18 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16EE4",
    fillRule: "evenodd",
    d: "M3.901 3.788C2.633 4.899 1.848 6.548 2.114 8.82l.006.075 7.127 11.196L15.88 8.929c0-.034.002-.07.006-.104.27-2.378-.523-4.044-1.779-5.136C12.815 2.565 10.947 1.98 9.014 2c-1.933.02-3.81.645-5.113 1.787zm13.843 5.654a.999.999 0 0 0 .13-.391c.341-3.004-.68-5.329-2.455-6.871C13.681.669 11.305-.024 8.993 0c-2.313.025-4.68.768-6.41 2.283C.819 3.83-.215 6.126.128 9.053c.017.152.068.29.143.412l-.114.072 8.276 13 .873 1.371.83-1.397 7.725-13-.117-.07zM7.534 6.444A1.245 1.245 0 0 0 7 7.5c0 .47.2.804.536 1.054.364.27.9.44 1.482.446.583.006 1.108-.153 1.46-.412.319-.236.525-.57.522-1.082-.003-.514-.215-.854-.54-1.093-.354-.26-.879-.419-1.458-.413-.579.006-1.11.175-1.47.444zm4.113-1.641c.803.59 1.346 1.508 1.354 2.69.007 1.187-.53 2.11-1.334 2.704-.772.57-1.749.812-2.668.803-.92-.01-1.889-.272-2.653-.84C5.554 9.575 5 8.668 5 7.5c0-1.164.548-2.07 1.336-2.659.762-.568 1.727-.831 2.646-.84.918-.01 1.891.233 2.664.802z",
    clipRule: "evenodd"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm10 2l-4.35-4.35"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm10 2l-4.35-4.35"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6521D3",
    fillRule: "evenodd",
    d: "M6.195 1.487a1 1 0 0 0-2 0V3.87h-.383A3 3 0 0 0 .974 7.84v15.004l.429.437.74.755.442.45h20.517l.44-.45.741-.755.43-.437V7.846a3 3 0 0 0-2.837-3.978h-1.009V1.497a1 1 0 0 0-2 0V3.87H6.195V1.487zM21.712 9.87H3.974v11.617h17.738V9.87z",
    clipRule: "evenodd"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-dark",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16EE4",
    fillRule: "evenodd",
    d: "M6.195 1.487a1 1 0 0 0-2 0V3.87h-.383A3 3 0 0 0 .974 7.84v15.004l.429.437.74.755.442.45h20.517l.44-.45.741-.755.43-.437V7.846a3 3 0 0 0-2.837-3.978h-1.009V1.497a1 1 0 0 0-2 0V3.87H6.195V1.487zM21.712 9.87H3.974v11.617h17.738V9.87z",
    clipRule: "evenodd"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-message-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.379 8.379 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-message-circle-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.379 8.379 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 22v-3a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M4 22h16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-dark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 22v-3a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M4 22h16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "s-icon-more-vertical",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM9 4.5A.75.75 0 1 0 9 3a.75.75 0 0 0 0 1.5zM9 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "s-icon-more-vertical-dark",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM9 4.5A.75.75 0 1 0 9 3a.75.75 0 0 0 0 1.5zM9 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "img-btn",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M10.08 18h15.5M18 10.8v15"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "img-btn-dark",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M10.08 18h15.5M18 10.8v15"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "message-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2C94C",
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.379 8.379 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "x",
    viewBox: "0 0 22 25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.354 6.354a.5.5 0 0 0-.708-.708L11 10.293 6.354 5.646a.5.5 0 1 0-.708.708L10.293 11l-4.647 4.646a.5.5 0 0 0 .708.708L11 11.707l4.646 4.647a.5.5 0 0 0 .708-.708L11.707 11l4.647-4.646z",
    clipRule: "evenodd",
    filter: "url(#b)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 30,
    height: 30,
    x: -4,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_1021"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_1021",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 15,
    height: 15,
    x: 3.5,
    y: 3.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_1021"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_1021",
    result: "shape"
  }))))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload-file",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#6521D3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M13.889 25h21.527M25 15.278V36.11"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload-file-dark",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#A16FF4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4043",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M13.889 25h21.527M25 15.278V36.11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteSheet);
export default __webpack_public_path__ + "static/media/spriteSheet.3f6681e8cf46334fdf57853295959ff4.svg";
export { ForwardRef as ReactComponent };